module.exports = __webpack_public_path__ + "img/1.eb123f1c.jpg";